import { sortBy, sumBy, uniqBy } from 'lodash-es';
import { DateTime } from 'luxon';
import * as React from 'react';
import { Flex } from '../../designSystem/components/flex';
import {
    DocumentUsersHoursFragment,
    EventsDocumentInput,
    UserHoursDocumentOptions
} from '../../generated/types';
import { DurationService } from '../../services/durationService';
import { useService, useTranslate } from '../../util/dependencies/dependencies';
import { isNonEmptyString } from '../../util/string';
import { filterStartEndDates } from '../../vo/positionSlotUserInfo';
import { DocumentContainer } from '../common/documentContainer';
import { UserHoursDayTable } from './userHoursDayTable';

interface IUserHoursProps {
    event: DocumentUsersHoursFragment;
    date?: DateTime;
    eventDocument: EventsDocumentInput;
    options: UserHoursDocumentOptions;
}

export const UserHours = (props: IUserHoursProps) => {
    const translate = useTranslate();
    const durationService = useService(DurationService);
    const vr = props.event.volunteerRegistration;
    const ui = vr.userInfo;
    const psuis = React.useMemo(
        () => filterStartEndDates(vr.positionsSlotsUsersInfos, props.date, null),
        [vr.positionsSlotsUsersInfos]
    );
    const days = React.useMemo(
        () =>
            sortBy(
                uniqBy(
                    psuis.map((psui) => psui.positionSlot.range.start!.startOf('day')),
                    (d) => d.toMillis()
                ),
                (d) => d.toMillis()
            ),
        [psuis]
    );
    const total = React.useMemo(() => sumBy(psuis, (psui) => psui.timeDifferenceMinutes), [psuis]);

    return (
        <DocumentContainer
            headerTitle1={`${isNonEmptyString(props.eventDocument.title) ? props.eventDocument.title : translate('UserHours')} ${ui.name}`}
            headerTitle2={translate(
                'total_d_heures_11826',
                durationService.minutesToHoursMinutesString(total)
            )}
            options={props.options}
        >
            <Flex direction="column" gap="4" width={1}>
                {days.map((day) => (
                    <UserHoursDayTable
                        key={day.toMillis()}
                        day={day}
                        psuis={psuis}
                        timeZone={props.event.timeZone}
                    />
                ))}
            </Flex>
        </DocumentContainer>
    );
};
